interface SectionHeaderProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

/**
 * Consistent section wrapper used throughout the editor.
 * Provides a clear visual boundary between sections with a left accent bar.
 */
export function SectionHeader({ title, description, children }: SectionHeaderProps) {
  return (
    <div className="mb-4">
      <div className="mb-2 flex items-center gap-2">
        <div className="h-4 w-1 rounded-radius-full bg-accent" />
        <h2 className="text-[11px] font-semibold uppercase tracking-wider text-text-primary">
          {title}
        </h2>
      </div>
      {description && (
        <p className="mb-2 ml-3 text-[10px] text-text-muted">{description}</p>
      )}
      <div className="ml-3 rounded-radius-sm border-l border-border-subtle pl-3">
        {children}
      </div>
    </div>
  );
}
